var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "40px",
    viewBox: "0 0 41 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "496C96AE-98D2-4EF0-AA92-9320C71FA8A0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insurance-agent-dashboard---8---Profile",
    transform: "translate(-861.000000, -198.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(787.000000, 118.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-49",
    transform: "translate(74.666667, 80.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F6931E",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-pencil-764777",
    transform: "translate(8.800000, 8.800000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.47298969,15.3245361 C3.29257732,15.1441237 3.00391753,15.1441237 2.82350515,15.3245361 L1.31707216,16.8309691 C1.27647918,16.9076454 1.23588454,16.9843216 1.19078351,17.0609938 L0.0992783505,22.3739835 C0.040643299,22.6897031 0.315773196,22.9693649 0.636020619,22.9107258 L5.94901031,21.8147258 C6.0256866,21.7741328 6.10236289,21.7335381 6.17903505,21.6884371 L7.68546804,20.1820041 C7.86588041,20.0015918 7.86588041,19.712932 7.68546804,19.5325196 L3.47298969,15.3245361 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3562887,4.44123711 C14.1758763,4.26082474 13.8872165,4.26082474 13.7068041,4.44123711 L5.09195876,13.0560825 C4.91154639,13.2364948 4.91154639,13.5251546 5.09195876,13.705567 L9.30474227,17.9183505 C9.48515464,18.0987629 9.77381443,18.0987629 9.9542268,17.9183505 L18.5690722,9.30350515 C18.7494845,9.12309278 18.7494845,8.83443299 18.5690722,8.65402062 L14.3562887,4.44123711 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8672165,4.35546392 L18.654433,0.142680412 C18.4740206,-0.0377319588 18.1853608,-0.0377319588 18.0049485,0.142680412 L15.975299,2.1723299 C15.7948866,2.35274227 15.7948866,2.64140206 15.975299,2.82181443 L20.1880825,7.03459794 C20.3684948,7.21501031 20.6571546,7.21501031 20.837567,7.03459794 L22.8672165,5.00494845 C23.0476289,4.82453608 23.0476289,4.53138144 22.8672165,4.35546392 L22.8672165,4.35546392 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImg);
export default __webpack_public_path__ + "static/media/edit-img.039f2ba4ad90f1eff41515febdcbb1fd.svg";
export { ForwardRef as ReactComponent };